import { apiPostFormRaw } from './client';
import type { DevToolsFileType, ParsedFileResponse } from '../types/DevTools';

export type ParseFileOutcome =
  | { ok: true; result: ParsedFileResponse }
  | { ok: false; error: string };

// POST /api/dev-tools/parse-file — multipart (fileType + file). Read-only
// preview: runs the file through its adapter and returns the parsed rows,
// never lands/shreds/ingests anything. Gated server-side by devTools:Edit.
export async function parseDevToolsFile(
  fileType: DevToolsFileType,
  file: File,
): Promise<ParseFileOutcome> {
  const form = new FormData();
  form.append('fileType', fileType);
  form.append('file', file);
  const res = await apiPostFormRaw('/api/dev-tools/parse-file', form);
  if (res.ok) {
    return { ok: true, result: (await res.json()) as ParsedFileResponse };
  }
  try {
    const body = await res.json();
    return { ok: false, error: body?.message ?? body?.error ?? `Parse failed (${res.status})` };
  } catch {
    return { ok: false, error: `Parse failed (${res.status})` };
  }
}
